module.exports = __webpack_public_path__ + "d70322c52c3dbaf81fe5676e19e1db5b.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-122.png
// module id = 110
// module chunks = 0